module.exports = __webpack_public_path__ + "img/australia-cerebrovascular-disease-male.a785e9e8.png";